import { COLLECTION_TAB_ORDER, COLLECTION_TABS, collectionTabForKind, collectionTabTitle, contentKindTitleLabel, playbackClass, playbackDestinationForKind, showsPlayControl, } from "@healthos/shared";
export const LIBRARY_CONTENT_TABS = COLLECTION_TABS;
export function tabForLibraryKind(kind) {
    return collectionTabForKind(kind);
}
export function tabForItem(item) {
    return collectionTabForKind(item.kind);
}
export function titleForTab(tab) {
    if (tab === "personalReset")
        return "Personal";
    return collectionTabTitle(tab);
}
export function displayKind(kind) {
    return contentKindTitleLabel(kind);
}
export function contentCardShowsPlayBadge(kind) {
    return showsPlayControl(kind);
}
export function destinationForContentItem(item) {
    return playbackDestinationForKind(item.kind);
}
export function videoUrlFromContentItem(item) {
    if (playbackClass(item.kind) !== "video")
        return null;
    return item.resetMedia?.videoUrl ?? null;
}
export function filterLibraryItems(items, activeTab, query, behaviours = []) {
    const q = query.trim().toLowerCase();
    return items.filter((item) => {
        if (activeTab !== "all" &&
            activeTab !== "brief" &&
            activeTab !== "personalReset" &&
            tabForItem(item) !== activeTab) {
            return false;
        }
        if (behaviours.length > 0 &&
            !behaviours.some((behaviour) => item.healthBehaviours.includes(behaviour))) {
            return false;
        }
        if (!q)
            return true;
        const tags = Array.isArray(item.metadata.tags)
            ? item.metadata.tags.filter((value) => typeof value === "string")
            : [];
        return [
            item.title,
            item.summary,
            displayKind(item.kind),
            ...tags,
            ...(item.healthBehaviours ?? []),
        ]
            .filter(Boolean)
            .some((value) => value?.toLowerCase().includes(q));
    });
}
export function librarySections(items, activeTab) {
    const tabs = activeTab === "all"
        ? [...COLLECTION_TAB_ORDER]
        : activeTab === "brief" || activeTab === "personalReset"
            ? []
            : [activeTab];
    return tabs
        .map((tab) => ({
        tab,
        title: titleForTab(tab),
        items: items.filter((item) => tabForItem(item) === tab),
    }))
        .filter((section) => section.items.length > 0);
}
export function itemHasTag(item, tag) {
    return (Array.isArray(item.metadata.tags) &&
        item.metadata.tags.some((value) => typeof value === "string" && value === tag));
}
export function itemMeta(item) {
    if (item.source === "recommended") {
        const why = typeof item.metadata.why === "string" ? item.metadata.why : null;
        if (why)
            return why;
    }
    const metadata = item.metadata;
    const when = typeof metadata.when === "string" ? metadata.when : null;
    if (when)
        return when;
    return contentKindTitleLabel(item.kind);
}
export function libraryCardMeta(item) {
    if (item.source === "recommended")
        return "Heartbeat recommended";
    return itemHasTag(item, "Made this") ? "Explore · Made this" : "Explore";
}
export function libraryCompletionLabel(kind) {
    if (kind === "Recipe")
        return "Made";
    if (kind === "Reset" || kind === "Guide" || kind === "Meditation")
        return "Watched";
    if (kind === "PodcastEpisode" || kind === "Soundscape" || kind === "BedtimeStory")
        return "Played";
    return "Read";
}
//# sourceMappingURL=content-surface.js.map